import React from 'react'
import glamorous from "glamorous"

const Page4Container = glamorous.div({
  marginTop: "200px",
  textAlign: "center",
  fontSize: "60px"
})

export const Page4 = () => {
  return <Page4Container>Page 4</Page4Container>
}


// WEBPACK FOOTER //
// ./src/components/Page4.js